import { render } from "./AddWidget.vue?vue&type=template&id=a47c139a&scoped=true"
import script from "./AddWidget.vue?vue&type=script&lang=js"
export * from "./AddWidget.vue?vue&type=script&lang=js"

import "../../../../reports/css/modal.css?vue&type=style&index=0&id=a47c139a&scoped=true&lang=css"
import "./AddWidget.vue?vue&type=style&index=1&id=a47c139a&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a47c139a"]])

export default __exports__